import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/customer-care.scss";

function PaymentSecurity() {
  return (
    <main className="policy-page customer-care">
      <header>
        <p className="eyebrow">Checkout</p>
        <h1>Payment &amp; security</h1>
        <p>Clear information about the payment choices represented in this storefront.</p>
      </header>
      <article className="policy-copy">
        <section><h2>Available methods</h2><p>The checkout interface presents Visa, Mastercard, American Express and PayPal. Availability may depend on the payment provider and customer location when a live payment service is connected.</p></section>
        <section><h2>Demonstration status</h2><p>This storefront is currently a frontend demonstration. It validates form structure locally but does not transmit, authorise or settle payment details.</p></section>
        <section><h2>Future live checkout</h2><p>Before accepting real payments, irtradeco must connect a compliant payment processor, enable encrypted transport and publish any provider-specific processing disclosures.</p></section>
        <section><h2>Pricing</h2><p>Prices are displayed in {siteConfig.currency.code}. Delivery charges and any applicable taxes are shown during checkout before an order is confirmed.</p></section>
        <section><h2>Questions</h2><p>For order or payment questions, contact <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>. Never send complete card details by email.</p></section>
      </article>
    </main>
  );
}

export default PaymentSecurity;
